// Copyright (C) Unite Digital LLC - All Rights Reserved.
// Unauthorized copying of this file, via any medium is strictly prohibited.
// Proprietary and confidential.
// Developed by Unite Digital LLC.

export interface Vehicle {
    dealerId?: number;
    bodyStyle: string;
    bodyType?: string;
    status?: string;
    lastUpdateDate?: Date; //date
    lastUpdatedBy?: number;
    make: string;
    model: string;
    stockNumber: string;
    trim: string;
    mileage?: number;
    vehicleExt: {
        bodyType?: string;
        exteriorColor?: string;
        images?: string; //used in vehicle lookup, or when selecting image for deal
        image?: string; //used in deal as selected image
        interiorColor?: string;
        priceInternet?: number;
        status?: string;
        [key: string]: string | string[] | number;
    };
    vin?: string;
    year?: number;
    manuallyCreated: boolean;
}

export interface VehicleCreation extends Vehicle {
    manuallyCreated: boolean;
}

export interface TradeInVehicle extends Vehicle {
    payoff?: number;
}

export interface VehicleMakeModel {
    oemCode: string;
    make: string;
    model: string;
}

export enum ReasonForRequestStatus {
    New = 'new',
    CPO = 'cpo',
    Used = 'used',
    Service = 'service',
}
